import React from 'react';
import { Typography, Tooltip } from '@mui/material';

const EllipsisText = ({
  text,
  maxWidth = 150,
  variant = 'body2',
  color = 'text.primary',
  sx = {},
  tooltipProps = {},
  ...typographyProps
}) => {
  if (!text) {
    return (
      <Typography variant={variant} color={color} sx={sx} {...typographyProps}>
        –
      </Typography>
    );
  }

  const ellipsisStyles = {
    maxWidth,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    ...sx,
  };

  return (
    <Tooltip title={text} {...tooltipProps}>
      <Typography
        variant={variant}
        color={color}
        sx={ellipsisStyles}
        {...typographyProps}>
        {text}
      </Typography>
    </Tooltip>
  );
};

export default EllipsisText;
